module.exports = __webpack_public_path__ + "img/slgt.07a299ee.png";